const STORAGE_KEY = 'jlfc_active_exploitant_id';
export const ACTIVE_EXPLOITANT_EVENT = 'jlfc-active-exploitant-change';

export function getActiveExploitantId() {
  return localStorage.getItem(STORAGE_KEY);
}

export function setActiveExploitantId(id) {
  if (id) localStorage.setItem(STORAGE_KEY, String(id));
  else localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(ACTIVE_EXPLOITANT_EVENT));
}

export function clearActiveExploitantId() {
  setActiveExploitantId(null);
}
